import $ from 'jquery';

import application from 'application/application';

application

	.directive('uploadImagePreview', ['uploadImagePreviewService', function(uploadImagePreviewService) {

		return {
			restrict: 'A',
			scope: {
				ngModel: '='
			},
			link: function(scope, element, attrs) {

				$(element)

					.on('click', function() {

						var

							object = {
								scope: scope,
								thumbElement: attrs.uploadImagePreview,
								thumbSize: attrs.imageSize || '200x200'
							};

						object.thumbSizeArray = object.thumbSize.split('x');

						object.thumbWidth = object.thumbSizeArray[0];

						object.thumbHeight = object.thumbSizeArray[1];

						uploadImagePreviewService.init(object, scope, element, attrs);

					});

			}
		};

	}]);
